import React from 'react'
import { useSelector } from 'react-redux';
import { selectStudentPreChecks } from '../studentPreChecksSlice';
import { CHECKED_ITEMS, STUDENT_PRE_CHECK_STATUS } from '../constants'

export default function FatalFailureScreen(){

    const studentPreChecks = useSelector(selectStudentPreChecks);

    return <div>
        <ul>
            { CHECKED_ITEMS.map( (item, i) => {
                if(studentPreChecks.contextStates.checks[item] === STUDENT_PRE_CHECK_STATUS.failed){
                    return <li key={i}>{item} failed to pass checks because {studentPreChecks.contextStates.errors[item]}</li>
                }
            })}
        </ul>
    </div>

}